"use strict";
// Type definitions for the preprocessing system
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircularSnippetError = exports.SnippetNotFoundError = exports.CircularDependencyError = exports.FileNotFoundError = exports.PreprocessorError = void 0;
/**
 * Error types that can occur during preprocessing
 */
class PreprocessorError extends Error {
    constructor(message, subAdventureName, loadingStack) {
        super(message);
        this.subAdventureName = subAdventureName;
        this.loadingStack = loadingStack;
        this.name = 'PreprocessorError';
    }
}
exports.PreprocessorError = PreprocessorError;
/**
 * File not found error
 */
class FileNotFoundError extends PreprocessorError {
    constructor(subAdventureName, basePath) {
        super(`Sub-adventure '${subAdventureName}' not found in '${basePath}'`, subAdventureName);
        this.name = 'FileNotFoundError';
    }
}
exports.FileNotFoundError = FileNotFoundError;
/**
 * Circular dependency error
 */
class CircularDependencyError extends PreprocessorError {
    constructor(loadingStack) {
        const chain = loadingStack.join(' -> ');
        super(`Circular sub-adventure dependency detected: ${chain}`, undefined, loadingStack);
        this.name = 'CircularDependencyError';
    }
}
exports.CircularDependencyError = CircularDependencyError;
/**
 * Snippet not found error
 */
class SnippetNotFoundError extends PreprocessorError {
    constructor(snippetName, checkedPaths) {
        const pathsList = checkedPaths.length > 0 ? ` Checked: ${checkedPaths.join(', ')}` : '';
        super(`Snippet '${snippetName}' not found.${pathsList}`, snippetName);
        this.snippetName = snippetName;
        this.checkedPaths = checkedPaths;
        this.name = 'SnippetNotFoundError';
    }
}
exports.SnippetNotFoundError = SnippetNotFoundError;
/**
 * Circular snippet dependency error (snippet A includes B includes A)
 */
class CircularSnippetError extends PreprocessorError {
    constructor(snippetStack) {
        const chain = snippetStack.join(' -> ');
        super(`Circular snippet dependency detected: ${chain}`, undefined, snippetStack);
        this.snippetStack = snippetStack;
        this.name = 'CircularSnippetError';
    }
}
exports.CircularSnippetError = CircularSnippetError;
//# sourceMappingURL=preprocessor.js.map